import React from 'react';
import Axios from 'axios';
import moment from 'moment';

// in case we need this feature
const MASTER_ADMIN = true;

class TeamAdmin extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			teamData: {
				_id: 0,
				seasonId: 0,
				name: '',
				homeSite: '',
				playersId: [],
				active: false
			},
			regDate: '',
		};
	
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
	}

 	componentDidMount() {
		this.loadTeamFromApi();
 	}

  loadTeamFromApi() {
    var _this = this;

    // 0 means a new player to add, no info to retreive
    if (this.props.match.params.teid !== 'newTeam') {

    	Axios.get('/api/teams/' + _this.props.match.params.teid + '/withMatchCount').then(function (response) {
				var teamData = response.data;
				var regDate = new Date(parseInt(teamData._id.toString().slice(0, 8), 16) * 1000);
	      regDate = moment(regDate).utc().format("YYYY-MM-DD");

				_this.setState({
					teamData: teamData,
	    		regDate: regDate
				});
    	});

    } else {
			var todaysDate = new Date();
	    var regDate = moment(todaysDate).utc().format("YYYY-MM-DD");
			_this.setState({
				regDate: regDate
			});
		}
	}

	handleSubmit(e) {
		e.preventDefault();
		var _this = this;
		var teamData = this.state.teamData;

		var savedTeamData = {
			_id: teamData._id,
			seasonId: teamData.seasonId,
			name: teamData.name,
			homeSite: teamData.homeSite,
			playersId: teamData.playersId
		};

		Axios.post('/api/teams/updateOneTeam', {
			teamData: savedTeamData
		})
		.then(function(response) {
			//console.log(response);
			const path = '/admsafe/teams';
			_this.props.history.push(path);
		})
		.catch(function(error) {
			console.log(error);
		});
	}
	
	render() {
		//console.log('TeamAdmin: render');
		var teamData = this.state.teamData;
		var teamIdInfo = 'Création d\'une nouvelle équipe';
		if(this.props.match.params.teid !== 'newTeam') {
			teamIdInfo = 'id: ' + this.props.match.params.teid;
		}

    var defaultDate = new Date();
    defaultDate = moment(defaultDate.toISOString()).utc().format("YYYY-MM-DD");

		return (
			<div className="row">
      <div className="col-md-12">
        <form className="form-horizontal" onSubmit={this.handleSubmit}>

					<div className="form-group">
          <div className="row">
          <div className="col-md-12">
            <h5>Ajout/Édition d'une Équipe</h5>
						{teamIdInfo}<br/>
					</div>
					</div>
					</div>

					<div className="form-group">
          <div className="row">
          <div className="col-md-6">
						Nom de l'équipe <br/>
						<input type="text" className="form-control" id="teamName" placeholder="Nom" 
							value={teamData.name} onChange={this.handleChange}/>
					</div>
					</div>
					</div>

					<div className="form-group">
          <div className="row">
          <div className="col-md-6">
						Domicile <br/>
						<input type="text" className="form-control" id="homeSite" placeholder="Nom" 
							value={teamData.homeSite} onChange={this.handleChange}/>
					</div>
					</div>
					</div>

					<div className="form-group">
          <div className="row">
          <div className="col-md-12">
						Saison:  {teamData.seasonName}<br/>
						Nombre de joueurs:  {teamData.playersId.length}<br/>
						Date Inscription:  {this.state.regDate}<br/>
						Nombre de matchs joués:  {teamData.tmrCount}<br/>
					</div>
					</div>
					</div>

					<div className="form-group">
          <div className="row">
          <div className="col-md-12">
						<button type="submit" className="btn btn-primary">Sauvegarder</button>&nbsp;&nbsp;&nbsp;&nbsp;
						<button type="button" className="btn btn-primary"
							onClick={this.handleCancel}>Annuler</button>&nbsp;&nbsp;&nbsp;&nbsp;
					</div>
					</div>
					</div>

				</form>
			</div>
			</div>
		);
	}

	handleChange(e) {
    this.setState({[e.target.id]: e.target.value});
	}

	handleCancel() {
		const path = '/admsafe/teams';
		this.props.history.push(path);		
	}

}

export default TeamAdmin;